import { httpClient } from "../http/httpClient";

export interface createTransactionCltParams {
  customerId: string;
  value: number;
  valorParcela: number;
  taxa: number;
  Prazo: number;
  codigoTabela: number;
  codigoOrgao: number;
  codigoEmpregador: number;
  matricula: number;
  cnpjEmpresa: number;
  tableCode: string;
}

interface createTransactionResponse {
  _id: string;
  contract: string;
  reason_to_cancel: string;
  value: number;
  status: string;
  statusAt: string;
  history?: any[];
  seller: string;
  customer: string;
  table: string;
  type: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
export async function createTransaction(params: createTransactionCltParams) {
  const { data } = await httpClient.post<createTransactionResponse>(
    "/clt/transaction",
    params,
  );
  return data;
}
